/* Herfeh motion layer — native Web Animations API, no dependencies.

   Previously powered by anime.js (118KB) for two small effects; the same
   entrances are ~40 lines of element.animate(), so the library was dropped.
   anime's `out(2)` (easeOutQuad) maps to cubic-bezier(.5, 1, .89, 1).

   Design rules (Apple "Designing Fluid Interfaces" + restrained house style):
   - Additive only. If the API is missing, if the visitor prefers reduced motion,
     or if IntersectionObserver is missing, every element stays in its normal
     painted state. Nothing is hidden by CSS, so a broken script can never
     leave the page blank.
   - No flicker. We only hide an element that is still BELOW the fold when the
     script runs, so the "from" state is applied while it is off-screen and
     unseen. Anything already on screen at load is left exactly as painted and
     never animates, so it can't blink out and back in.
   - One curve, shared with the CSS. EASE below is the same cubic-bezier as
     --ease-out in base.css, so a scroll reveal and a hover state decelerate
     identically. It replaces anime's easeOutQuad, which was the weakest of the
     ease-outs and made every entrance land flat.
   - Long settle, short travel. With this curve ~80% of the distance is covered
     in the first third of the duration, so a 680ms reveal reads as arriving in
     about 200ms and then coming to rest. That gap between "arrived" and
     "finished" is what separates unhurried from slow.
   - Never overshoot. Bounce on a fade-in reads as fidgety, not fluid. */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window) || !document.body || !document.body.animate) return;

  var EASE = 'cubic-bezier(.2, .7, .2, 1)';   /* === --ease-out in base.css. Keep the two in step. */

  function viewportH() {
    return window.innerHeight || document.documentElement.clientHeight || 0;
  }

  function whenSeen(el, run, margin) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        run(e.target);
      });
    }, { rootMargin: margin || '0px 0px -8% 0px', threshold: 0 });
    io.observe(el);
  }

  /* Play a keyframe pair on `el`. The inline from-state is cleared first so the
     element's natural painted state is the base the animation lands on — with
     no fill:forwards, the finished animation therefore never snaps back. */
  function play(el, frames, duration, delay) {
    el.style.opacity = '';
    el.style.transform = '';
    el.animate(frames, {
      duration: duration,
      delay: delay || 0,
      easing: EASE,
      fill: 'backwards'   /* holds the from-state during `delay`, so staggered items stay hidden until their turn */
    });
  }

  /* Reveal an element only if it starts below the fold. `hide` applies the
     from-state (while unseen, so no flicker); `run` animates it in on entry.
     Elements already on screen at load return early: untouched, no animation. */
  function onScrollIn(el, hide, run, margin) {
    if (el.getBoundingClientRect().top < viewportH()) return;
    hide();
    whenSeen(el, run, margin);
  }

  /* 1. Tatreez clusters fade and settle in, one diamond at a time. */
  document.querySelectorAll('.motif-cluster-svg').forEach(function (cluster) {
    var diamonds = cluster.querySelectorAll('.mc-d');
    if (!diamonds.length) return;
    onScrollIn(
      cluster,
      function () {
        for (var i = 0; i < diamonds.length; i++) diamonds[i].style.opacity = '0';
      },
      function () {
        for (var i = 0; i < diamonds.length; i++) {
          play(
            diamonds[i],
            [
              { opacity: 0, transform: 'scale(.9)' },
              { opacity: 1, transform: 'scale(1)' }
            ],
            760,
            i * 80   /* stagger — six diamonds, so the last starts at 400ms and the
                        cluster completes around 1.16s. At the old 55ms the six read
                        as one blurred event; 80ms is slow enough to see them land
                        one at a time, which is what the motif is of. */
          );
        }
      },
      '0px 0px -42% 0px'   // fire later — only once the cluster is well into view
    );
  });

  /* 3. The "Made to Belong" band stitches itself in on arrival: the weave settles
        and the divider draws outward. Class-driven, because the transitions live
        in the section's own stylesheet. Bands already on screen at load are left
        alone by the same no-flicker rule used above. */
  document.querySelectorAll('.belong-band').forEach(function (band) {
    if (band.getBoundingClientRect().top < viewportH()) return;
    band.classList.add('js-anim');
    whenSeen(band, function () { band.classList.add('in'); }, '0px 0px -25% 0px');
  });

  /* 2. Section headings rise a few pixels as they come into view. */
  document.querySelectorAll('.section-head, .story-band__inner').forEach(function (el) {
    onScrollIn(
      el,
      function () { el.style.opacity = '0'; },
      function () {
        play(
          el,
          [
            { opacity: 0, transform: 'translateY(16px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          /* 440ms of easeOutQuad over 12px was a move you noticed ending. 680ms
             of the house curve over 16px is a move you notice starting — it is
             visually done well before the timer is, and the extra travel gives
             the settle something to settle from. */
          680
        );
      },
      '0px 0px -12% 0px'   // let the heading clear the fold properly before it moves
    );
  });
})();
